import type { MultiSelectOption } from '@vnetwork/ui/primitives';

/**
 * Interested-service choices for journey deal info + create-journey forms.
 * Mirrors the customer-new `SERVICE_INTEREST_OPTIONS` so a journey's
 * `service_interestings` slugs render with the same labels everywhere.
 */
// Labels stay plain strings (not `ReactNode`) so the lookup below is text.
export const SERVICE_INTEREST_OPTIONS = [
  { value: 'cdn', label: 'CDN' },
  { value: 'cloud', label: 'Cloud / Hosting' },
  { value: 'security', label: 'Security (WAF / Anti-DDoS)' },
  { value: 'network', label: 'Network / Connectivity' },
  { value: 'domain', label: 'Domain / DNS' },
  { value: 'email', label: 'Email service' },
  { value: 'sms', label: 'SMS / Communication' },
  { value: 'other', label: 'Other' },
] satisfies MultiSelectOption[];

/** slug → display label lookup for read-only chips. */
export const SERVICE_INTEREST_LABELS: Record<string, string> = Object.fromEntries(
  SERVICE_INTEREST_OPTIONS.map((o) => [o.value, o.label]),
);
